module.exports = __webpack_public_path__ + "static/media/collapse.d6f95a6f.svg";